import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withApp } from 'helpers'
import { Page, Animation, PageTitle, PageContent, PageFooter, Heading, Text, Button, ButtonsGroup, Image } from 'components/library'
import { Container, Row, Col } from 'react-grid-system'
import { bindActionCreators } from 'redux'
import * as accountActions from 'store/actions/accountActions'
import { translate } from 'translations'
import endTestimg from './assets/Cyclus.svg'
import {config} from './../../../config';

class EndtestNotPassedView extends React.Component {
  componentDidMount() {
    const nav = this.props.navigation.find(item => item.type === 'endtest')
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  handleRestart = e => {
    if(!this.props.endtest.passed) {
      this.props.accountActions.updateEndtest({
        completed: false,
        passed: false,
        score: 0,
        answers: [],
      })
    }

    this.props.history.push(Routes.to('endtestTest'))
  }

  render() {
    return (
      <Page>
        <Animation name="slideInDown" delay={100}>
          <PageTitle>
            <Heading h1>{translate('endtest.notPassedTitle')}</Heading>
            <Heading em>{translate('endtest.notPassedDescription')}</Heading>
          </PageTitle>
        </Animation>

        <Animation delay={200}>
          <PageContent>
            <Container>
              <Row align="center">
                <Col sm={6}>
                  <Heading h2>{this.props.endtest.score}/{this.props.endtest.answers.length} punten gehaald</Heading>
                  <Text>Je moet <strong>minstens {config.scoreToPass} punten</strong> halen op de zelftoets om deze e-learning over het uitvoeren van een sleepbeweging af te ronden.</Text>
                  <Text style={{ margin: '2rem 0' }}>Bekijk je antwoorden en neem de voor jou relevante hoofdstukken door om te zorgen dat je de juiste kennis hebt.</Text>
                  <Text>Daarna kun je nogmaals proberen om de zelftoets te halen!</Text>
                </Col>
                <Col sm={6}>
                  <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center' }}>
                    <Image style={{ width: '30rem' }} src={endTestimg} aspectRatio={100} />
                  </div>
                </Col>
              </Row>
            </Container>
          </PageContent>
        </Animation>

        <Animation delay={300}>
          <PageFooter>
            <div className="Page-footer-left">
              <Button outline to={Routes.to('home')} icon="home" />
            </div>

            <div className="Page-footer-right">
              <div></div>
              <ButtonsGroup>
                <Button primary square to={Routes.to('endtestTest')} label={translate('endtest.btnResults')} />
                <Button primary square onClick={this.handleRestart} label={translate('endtest.btnRetry')} />
              </ButtonsGroup>
            </div>
          </PageFooter>
        </Animation>
      </Page>
    )
  }
}

export default withRouter(withApp(connect(
  (state, props) => ({
    endtest: state.account.endtest,
    navigation: state.content.navigation,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(EndtestNotPassedView)))



// WEBPACK FOOTER //
// ./src/components/views/endtest/EndtestNotPassedView.js